import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>HARDWARE AUTOMATION</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 Our hardware automation solutions are engineered to optimize mechanical and electrical systems through advanced control technologies. We design and integrate systems involving programmable logic controllers (PLC), sensors, actuators, and embedded devices to automate tasks across industries such as manufacturing, energy, and logistics. Our focus is on improving operational speed, reliability, and precision while reducing downtime and human error.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-boxes fa-3x mb-3 text-primary"></i>
        <hr className="my-3" />
        <h5>Embedded Systems</h5>
        <div className="btSubTitle small">
          These are dedicated computer systems built into hardware devices to perform specific tasks. Microcontrollers, microprocessors, and custom PCBs (Printed Circuit Boards) are core components. They enable real-time control and automation of hardware functions.
        </div>
       
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-patch-minus fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>Sensors and Actuators</h5>
        <div className="btSubTitle small">
          •	Sensors detect physical parameters like temperature, pressure, motion, or proximity.<br />
•	Actuators convert electrical signals into mechanical movement (e.g., motors, solenoids, pneumatic cylinders).

        </div>
      
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-arrows-move fa-3x mb-3 text-danger"></i>
        <hr className="my-3" />
        <h5>Motion Control Systems</h5>
        <div className="btSubTitle small">
          Used in robotics, CNC machines, and automated equipment, these systems control the position, velocity, and acceleration of motors and mechanical components with high precision.
        </div>
        
      </Col>
    </Row>
    <br />
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i class="bi bi-diagram-3 fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Communication Protocols</h5>
        <div className="btSubTitle small">
          Hardware automation systems use industrial communication protocols like Modbus, CAN, Profibus, or EtherCAT to enable data exchange between controllers, sensors, and actuators.
        </div>
      
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-motherboard fa-3x mb-3 text-secondary"></i>
        <hr className="my-3" />
        <h5>Real-Time Monitoring and Control</h5>
        <div className="btSubTitle small">
        Automation systems are designed for real-time performance—responding to changes in conditions immediately to maintain process stability and safety.
        </div>
       
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-arrow-left-right fa-3x mb-3 text-info"></i>
       
        <hr className="my-3" />
        <h5>Integration with Software Automation</h5>
        <div className="btSubTitle small">
         Modern hardware automation is often integrated with software platforms for data analytics, predictive maintenance, and centralized control through SCADA or IoT dashboards.
        </div>
      
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
